import {} from "../../request/api";
const state = {
    baseInfo: {
        cName: 'v-line',
        showHander: false,
        editId: null,
        showAdd: false,
        showEdit: false,
    },
};
const mutations = {
    changeEditId(state, id) {
        state.baseInfo.editId = id;
    },
    changeShowHander(state, bool) {
        state.baseInfo.showHander = bool;
    },
    changeShowAdd(state, bool) {
        state.baseInfo.showAdd = bool;
    },
    changeShowEdit(state, bool) {
        state.baseInfo.showEdit = bool;
    },
};
const actions = {

};

const getters = {
    editId(state) {
        return state.baseInfo.editId;
    },
    showHander(state) {
        return state.baseInfo.showHander;
    },
    showAdd(state) {
        return state.baseInfo.showAdd;
    },
    showEdit(state) {
        return state.baseInfo.showEdit;
    },

};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}